import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

export const RemoteSupportMenuItem = ({ label, testId }) => {
  const [info, setInfo] = useState(null);
  const open = async () => {
    try { const { data } = await api.get("/studio/assistenza-remota"); setInfo(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  const download = () => { window.location.href = `${process.env.REACT_APP_BACKEND_URL}${info.url}`; setInfo(null); };
  return (
    <>
      <button type="button" onClick={open} data-testid={testId}
        className="block w-full text-left rounded-md px-3 py-2 text-[13px] transition-colors truncate text-slate-400 hover:text-cyan-400 hover:bg-slate-800/50">
        {label}
      </button>
      <AlertDialog open={!!info} onOpenChange={(o) => !o && setInfo(null)}>
        <AlertDialogContent data-testid="remote-support-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Assistenza Remota</AlertDialogTitle>
            <AlertDialogDescription asChild>
              <div className="whitespace-pre-wrap text-sm text-slate-600 max-h-[50vh] overflow-y-auto" data-testid="remote-support-istruzioni">
                {info?.istruzioni || "Avvia il file scaricato e comunica all'operatore il codice che compare a schermo."}
              </div>
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="remote-support-cancel">Annulla</AlertDialogCancel>
            <AlertDialogAction onClick={download} data-testid="remote-support-request">Richiedi Assistenza</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};
